import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import {  useHistory } from "react-router-dom";

import { Stack } from '@fluentui/react';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { authGetClient, sendAADInvitation } from "../../../actions/auth-action";
import { useDispatch, useSelector } from "react-redux";
import MessageBox from "../Message/MessageBox";
import { __MessageTypes } from "../../../common/Dictionaries";
import { showMessage } from "../../../common/Helpers";

const ProfileOptionButtons = (props) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const { user: currentAuth } = useSelector((state) => state.auth);

    const listItems = props.items;
    const userInfo = props.userInfo;
    const { disabled, checked } = props;
    const stackTokens = { childrenGap: 40 };
    
    let menuProps = {
        items: []
    };

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    listItems.filter(x => currentAuth.profile.includes("sAdmin") ? true : x.key !== "aadinvite").map((item, index) => {
        if (item.show) {
            menuProps.items.push({
                key: item.key,
                text: item.text,
                iconProps: { iconName: item.iconName },
                className: "ms-Icon-custom",
                onClick: item.key === 'aadinvite' ? onSendAADInvitation :  onAlertClick,
            });
        }
    });    
    
    function onAlertClick(ev, item) {   
        const url = item.key;
        const value = listItems.find(x => x.key === item.key).stateValue;

        history.push(`/${url}`, value);
    }

    function onSendAADInvitation(ev, item) {  
        const userClientId = authGetClient();
        
        dispatch(sendAADInvitation(userInfo.username, userClientId)).then((response) => {
            if (response.data.succeeded === true) {
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t(response.data.message)) 
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(response.data.message)) 
            }
        }).catch((ex) => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror')) 
        });
    }
    
    return (
        <>
            <div data-html2canvas-ignore="true" className="float-end">
                <Stack horizontal wrap tokens={stackTokens}>
                    <DefaultButton
                        text={t('data-lang-lbl-options')}
                        primary
                        split
                        onClick={null}
                        menuProps={menuProps}
                        disabled={disabled}
                        checked={checked}
                    />
                </Stack>
            </div>
            <MessageBox
                inputParam_Message={ messageConfig.message }
                inputParam_Display={ messageConfig.showMessage }
                inputParam_MessageType={ messageConfig.messageType }
                inputParam_SetterMessage={ setMessageConfig }
            />
        </>
    );
};

export default ProfileOptionButtons;


